module.exports = __webpack_public_path__ + "assets/img/arrows-fullscreen.b54e1dff.svg";